import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentSignOut = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">8.Sign Out</h2>
            <div>
                <p>This option is used to sign out from the developer portal.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/sign_out.png"} />
            </div>

            <div>
                <h3>Steps to log out from Portal</h3>
                <p><span className="font-bold">Step 1:</span> Click on User Name display icon present at the right hand side corner of page header as shown in the above screenshot. </p>
                <p><span className="font-bold">Step 2:</span> On clicking, you would get two options in the form of a drop-down:- 1. User profile 2. Sign Out</p>
                <p><span className="font-bold">Step 3:</span>Step 3: Click on <span className="font-bold">Sign Out</span> Option to log-out</p>
            </div>

        </div>
    )
}

export default ContentSignOut;